// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root___WV8j"};